import { render } from "./aboutBlocks.vue?vue&type=template&id=2e3c19ca"
import script from "./aboutBlocks.vue?vue&type=script&lang=js"
export * from "./aboutBlocks.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__